/**
 * Add or remove one label from a multi-select label filter.
 *
 * Lives here rather than beside the component so it can be tested directly:
 * Radix's dropdown does not open under jsdom (it needs pointer-capture APIs
 * jsdom lacks), which is why the label filter tests in this app only ever assert
 * the trigger's state. Exporting it from the component file also trips
 * react-refresh, which wants component files to export components only.
 */
export function toggleLabelSelection(selected: string[], labelId: string): string[] {
  return selected.includes(labelId)
    ? selected.filter((id) => id !== labelId)
    : [...selected, labelId];
}
